import axios from "../axios";

/**
 * 保存
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const save = (data) => {
  return axios({
    url: "/hhb/save",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}
/**
 * 获取会员个人的记录
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const getListByDeptId = (data) => {
  return axios({
    url: "/hhb/getListByDeptId",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

export const getRecordById = (data) => {
  return axios({
    url: "/hhb/getRecordById",
    method: 'post',
    data
  })
}

export const downloadApplication = (data) => {
  return axios({
    url: '/hhb/downloadApplication',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}
let openDownloadDialog = function (blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}
/**
 * 同意红花杯申报
 */
export const approveHhbsb = (data) => {
  return axios({
    url: "/hhb/approveHhbsb",
    method: 'post',
    data
  })
}

export const rejectHhbsb = (data) => {
  return axios({
    url: "/hhb/rejectHhbsb",
    method: 'post',
    data
  })
}

export const getHhbpsList = (data) => {
  return axios({
    url: '/hhb/getHhbpsList',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

export const getHhbRecordVInfoById = (data) => {
  return axios({
    url: "/hhb/getHhbRecordVInfoById",
    method: 'post',
    data
  })
}

export const saveHbbPsResult = (data) => {
  return axios({
    url: "/hhb/saveHbbPsResult",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}

export const getSbtjbList = (data) => {
  return axios({
    url: "/hhb/getSbtjbList",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })

}

export const exportSbtjb = (name, data) => {
  return axios({
    url: "/hhb/exportSbtjb",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
    data: data
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}


export const getPstjb = (data) => {
  return axios({
    url: "/hhb/getPstjb",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })

}


export const exportPsthb = (name, data) => {
  return axios({
    url: "/hhb/exportPstjb",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
    data: data
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })

}

/**
 * 获取红花杯申报方法 pdf文件
 * @returns {Promise | Promise<unknown>}
 */
export const getHhbpsPDF = () => {
  return axios({
    url: "/hhb/getHhbpsPDF",
    method: 'get',
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/hhb.js